import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { DataGrid } from "@mui/x-data-grid";
import MDBox from 'components/MDBox';
import { isEmpty } from "utils/validationUtil";
// import { IconButton } from "@mui/material";
// import { Edit } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { GridSearchToolbar } from "app/components/common/GridQuickSearchField";
import { compareText } from "utils/optionSort";
import { DEFAULT_TABLE_PAGE_SIZE } from "AppConstants";

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

// Default order: Client Code, then the person's name within it. Sorted on the rows, not
// through a sortModel: the community DataGrid keeps only the first item of one. Ordering
// follows the code the column shows, so the order reads correctly down the page.
// @since NEXT_VERSION
const clientSortKey = (row) => row.client?.code ?? row.client?.name ?? "";

const sortByClientThenName = (rows) =>
  (Array.isArray(rows) ? [...rows] : []).sort(
    (a, b) => compareText(clientSortKey(a), clientSortKey(b)) || compareText(a.name, b.name)
  );

export const TeamMemberDataGridBase = (props) => {
    const columns = [
        { field: 'id', headerName: 'Member Id', width: 120 },
        //{ field: 'userId', headerName: 'User Id', width: 120 },
        { field: 'client_code', headerName: 'Client Code', width: 150, valueGetter: (value, row) => row.client?.code ?? "—" },
        { field: 'name', headerName: 'User Name', width: 320, renderCell: (params) =>
        <Link href="#" onClick={() => handleClickEvent(params.row)} >{params.row.name}</Link>, // getAction
        },
        { field: 'email', headerName: 'Email', width: 280 },
    ]
    const handleClickEvent = (row) => {
        props.clickEventHandler(row);
        return false;
    }

    const getData = () => {
        if(isEmpty(props.membersData) || props.membersData.length === 0)
            return [];
        else
            return sortByClientThenName(props.membersData);
    }

    // Every view backed by this grid loads its full member list up front, so the
    // quick filter runs client side over the loaded rows (HRMS-310).
    const toolbarSlotProps = useMemo(() => ({ placeholder: "Search members..." }), []);
    
    return (
        <MDBox pt={3}
            py={3}
            px={2}
            height={500}
        >
            <DataGrid
                density="compact"
                // sx={{ margin: 2 }}
                rows={ getData() }
                columns={columns}
                pageSizeOptions={PAGE_SIZE_OPTIONS}
                initialState={{
                    // The member id is an internal key, so it is off by default and stays
                    // reachable from the column menu.
                    columns: { columnVisibilityModel: { id: false } },
                    pagination: { paginationModel: { pageSize: DEFAULT_TABLE_PAGE_SIZE } },
                }}
                loading={props.isLoading}
                showToolbar
                slots={{ toolbar: GridSearchToolbar }}
                slotProps={{ toolbar: toolbarSlotProps }}
                // Member ids and manager ids are separate id spaces and can collide, so a row
                // that is not a member carries its own key.
                getRowId={(row) => row.rowKey ?? row.id}
            />
        </MDBox>
    );
}

TeamMemberDataGridBase.propTypes = {
    membersData: PropTypes.array.isRequired
}
